import React from 'react';

import { styled } from '@mui/material/styles';

import FormItemLayout, { FormItemLayoutProps } from '../../../../ui/Forms/FormItemLayout';

const StyledFormItemLayout = styled(FormItemLayout)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  margin: theme.spacing(0.5, 0),
  padding: theme.spacing(2, 2.5),
}));

type StaffOnlyFormItemLayoutProps = Omit<FormItemLayoutProps, 'staffOnlyTag'> & {
  labelId: TranslationId;
};

const StaffOnlyFormItemLayout = ({
  alignItems = 'center',
  removeRootPaddings = true,
  ...props
}: StaffOnlyFormItemLayoutProps) => (
  <StyledFormItemLayout
    {...props}
    staffOnlyTag
    alignItems={alignItems}
    removeRootPaddings={removeRootPaddings}
  />
);

export default StaffOnlyFormItemLayout;
